import { render, staticRenderFns } from "./presentations.vue?vue&type=template&id=01361cc4"
import script from "./presentations.vue?vue&type=script&lang=js"
export * from "./presentations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports